module.exports = __webpack_public_path__ + "static/logo@2x-341125248bf5a9b07cb25a32bbf878a9.png";